document.addEventListener('DOMContentLoaded', function() {
  // Accessibility enhancements
  initExternalLinks();
  announceSuccessMessages();
  focusVirtualShoppingSuccess();
  warnOnReloadingFormSubmitters();
  warnOnReloadingFilters();
  BacktoTop();
  initFilterAccessibility();
  updateRegistryHeading();
  initArticleLanguageTags();
  initIframeTitles();
  removeInvalidLinkRoles();
  initVariantOptionAccessibility();
  initImageInfoAccordions()
});

function isInternalHost(hostname) {
  if (!hostname) return true;
  const currentHost = window.location.hostname.replace(/^www\./, '').toLowerCase();
  const linkHost = hostname.replace(/^www\./, '').toLowerCase();

  if (linkHost === currentHost) return true;
  if (linkHost === 'macrobaby.com' || linkHost.endsWith('.macrobaby.com')) return true;
  if (linkHost.endsWith('.myshopify.com')) return true;

  return false;
}

function initExternalLinks() {
  const links = document.querySelectorAll("a[href]");

  links.forEach((link) => {
    try {
      const href = link.getAttribute("href");
      if (!href) return;

      if (
        href.startsWith("#") ||
        href.startsWith("mailto:") ||
        href.startsWith("tel:") ||
        href.startsWith("javascript:")
      ) {
        return;
      }

      const url = new URL(href, window.location.origin);
      const isInternal = href.startsWith("/") || isInternalHost(url.hostname);

      if (isInternal) {
        // Ensure internal links navigate in the same tab
        if (link.getAttribute("target") === "_blank" && !link.hasAttribute("data-keep-target-blank")) {
          link.removeAttribute("target");
          if (link.getAttribute("rel") === "noopener noreferrer" || link.getAttribute("rel") === "noopener") {
            link.removeAttribute("rel");
          }
        }
        return;
      }

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      const currentAria = link.getAttribute("aria-label") || "";
      const warning = "Redirecting to Third party Website, (Opens in new Tab)";
      const stripWarning = (value) => value
        .replace(/,?\s*Redirecting to Third party Website,?\s*\(Opens in new Tab\)/gi, "")
        .trim();

      // Use the rendered link text first so speech-control users can address
      // the link by the label they can see. aria-label takes precedence over
      // text in the accessibility tree, so keep it aligned with that text.
      const visibleLabel = link.textContent.replace(/\s+/g, " ").trim();
      let label = visibleLabel || stripWarning(currentAria);

      // If no direct text, extract alt attribute from nested image
      if (!label) {
        const img = link.querySelector("img[alt]");
        if (img && img.getAttribute("alt")) {
          label = img.getAttribute("alt").trim();
        }
      }

      // If still no text, check for SVG title or aria-label
      if (!label) {
        const svg = link.querySelector("svg");
        if (svg) {
          const svgTitle = svg.querySelector("title");
          label = (svg.getAttribute("aria-label") || (svgTitle ? svgTitle.textContent : "")).trim();
        }
      }

      // If still no text, check link title attribute
      if (!label && link.getAttribute("title")) {
        label = link.getAttribute("title").trim();
      }

      const finalLabel = label ? `${label}, ${warning}` : warning;

      link.setAttribute("aria-label", finalLabel);
    } catch (err) {
      console.error("initExternalLinks: skipped a link due to error", link, err);
    }
  });
}
function announceSuccessMessages() {
  const announcement = document.getElementById("global-form-success-announcement");
  if (!announcement) return;

  const successMessages = document.querySelectorAll(
    ".alert--success, .cmb-success, #successMessage"
  );
  const messageText = Array.from(successMessages)
    .map((message) => message.textContent.trim())
    .filter(Boolean)
    .join(" ");

  if (messageText) {
    announcement.textContent = messageText;
  }
}

function focusVirtualShoppingSuccess() {
  const successMessage = document.querySelector("#mb-vc .success-msg");
  if (!successMessage) return;

  successMessage.setAttribute("tabindex", "-1");

  const focusIfVisible = () => {
    if (getComputedStyle(successMessage).display !== "none" && successMessage.textContent.trim()) {
      successMessage.focus();
    }
  };

  focusIfVisible();

  new MutationObserver(focusIfVisible).observe(successMessage, {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true
  });
}

function warnOnReloadingFormSubmitters() {
  let warningIndex = 0;
  document.querySelectorAll("form").forEach((form) => {
    if (
      form.matches(".search-bar, [data-ajax-form]") ||
      form.closest("#mb-vc") ||
      form.querySelector('[data-action="add-to-cart"]')
    ) {
      return;
    }

    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((submitter) => {
      if (submitter.dataset.reloadWarningAttached) return;

      const warning = document.createElement("span");
      warning.id = `form-submit-reload-warning-${warningIndex++}`;
      warning.className = "visually-hidden";
      warning.textContent = "Submitting this form will reload the page.";
      submitter.insertAdjacentElement("afterend", warning);

      const describedBy = submitter.getAttribute("aria-describedby");
      submitter.setAttribute(
        "aria-describedby",
        describedBy ? `${describedBy} ${warning.id}` : warning.id
      );
      submitter.dataset.reloadWarningAttached = "true";
    });
  });
}
 window.addEventListener("load", function () {
  const errorMessage =
    document.getElementById("login-form-error") ||
    document.getElementById("register-form-error");

  if (!errorMessage) return;

  let count = 0;

  const focusInterval = setInterval(function () {
    errorMessage.focus();
    count++;

    if (count >= 10) {
      clearInterval(focusInterval);
    }
  }, 100);
});

document.querySelectorAll(
  '.nav-bar .nav-bar__item #products-dropdown .nav-dropdown__item.has-submenu > a'
).forEach(function (link) {

  link.removeAttribute('href');
  link.setAttribute('role', 'button');
  link.setAttribute('tabindex', '0');

  var text = link.textContent.trim();

  link.setAttribute('aria-label', text + ' submenu');

});
  function BacktoTop() {
  const backToTop = document.getElementById("back-to-top");
  const skipContent = document.getElementById("skip-to-content");

  if (!backToTop) return;

  function toggleBackToTop() {
    if (window.scrollY > 300) {
      backToTop.hidden = false;
    } else {
      backToTop.hidden = true;
    }
  }

  window.addEventListener("scroll", toggleBackToTop);

  backToTop.addEventListener("click", function () {

    if (skipContent) {

      // Make skip target focusable
      skipContent.setAttribute("tabindex", "-1");

      // Move page to top
      skipContent.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

      // Move keyboard focus
      setTimeout(function () {
        skipContent.focus();
      }, 300);

    } else {

      // fallback
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

    }

  });

}

function warnOnReloadingFilters() {
  var filterCheckboxes = document.querySelectorAll('.collection__filter-checkbox input[type="checkbox"]');
  var swatchButtons = document.querySelectorAll('.color-swatch__button[data-action="toggle-tag"]');
  var clearButtons = document.querySelectorAll('[data-action="clear-tags"]');

  if (!filterCheckboxes.length && !swatchButtons.length && !clearButtons.length) return;

  var reloadWarningSpan = document.getElementById('filter-reload-warning-text');
  if (!reloadWarningSpan) {
    reloadWarningSpan = document.createElement('span');
    reloadWarningSpan.id = 'filter-reload-warning-text';
    reloadWarningSpan.className = 'visually-hidden';
    reloadWarningSpan.textContent = 'Selecting this filter will reload the page.';
    document.body.appendChild(reloadWarningSpan);
  }

  var clearWarningSpan = document.getElementById('filter-clear-reload-warning-text');
  if (!clearWarningSpan) {
    clearWarningSpan = document.createElement('span');
    clearWarningSpan.id = 'filter-clear-reload-warning-text';
    clearWarningSpan.className = 'visually-hidden';
    clearWarningSpan.textContent = 'Clearing filters will reload the page.';
    document.body.appendChild(clearWarningSpan);
  }

  var attachWarning = function(elements, warningId) {
    elements.forEach(function(el) {
      if (el.dataset.reloadWarningAttached) return;
      var existingDesc = el.getAttribute('aria-describedby');
      if (!existingDesc) {
        el.setAttribute('aria-describedby', warningId);
      } else if (existingDesc.indexOf(warningId) === -1) {
        el.setAttribute('aria-describedby', existingDesc + ' ' + warningId);
      }
      el.dataset.reloadWarningAttached = 'true';
    });
  };

  attachWarning(filterCheckboxes, 'filter-reload-warning-text');
  attachWarning(swatchButtons, 'filter-reload-warning-text');
  attachWarning(clearButtons, 'filter-clear-reload-warning-text');
}

function initFilterAccessibility() {
  warnOnReloadingFilters();

  function captureFilterAction(event) {
    var target = event.target;
    if (!target) return;

    // Check for clear all filters action
    var clearBtn = target.closest ? target.closest('[data-action="clear-tags"]') : null;
    if (clearBtn) {
      try {
        sessionStorage.setItem('mb_filter_a11y', JSON.stringify({
          isClear: true,
          timestamp: Date.now()
        }));
      } catch (err) {}
      return;
    }

    var input = null;
    var swatch = null;

    if (target.matches && target.matches('input[data-action="toggle-tag"]')) {
      input = target;
    } else if (target.closest) {
      input = target.closest('input[data-action="toggle-tag"]');
      if (!input) {
        var label = target.closest('label');
        if (label && label.getAttribute('for')) {
          input = document.getElementById(label.getAttribute('for'));
        }
      }
      if (!input) {
        var filterCheckboxLi = target.closest('.collection__filter-checkbox');
        if (filterCheckboxLi) {
          input = filterCheckboxLi.querySelector('input[data-action="toggle-tag"]');
        }
      }
      if (!input) {
        swatch = target.closest('.color-swatch__button[data-action="toggle-tag"]');
      }
    }

    var el = input || swatch;
    if (!el) return;

    var tag = el.getAttribute('data-tag');
    var name = el.getAttribute('data-tag-user') || el.getAttribute('aria-label') || '';
    if (!name && el.id) {
      var labelEl = document.querySelector('label[for="' + el.id + '"]');
      if (labelEl) name = labelEl.textContent.trim();
    }

    // Determine whether this action is applying or removing the filter
    var wasChecked = input ? input.checked : (el.getAttribute('aria-pressed') === 'true');
    var willBeApplied = (event.type === 'change') ? input.checked : !wasChecked;
    var isMobile = !!el.closest('#mobile-collection-filters');

    try {
      sessionStorage.setItem('mb_filter_a11y', JSON.stringify({
        tag: tag,
        name: name,
        id: el.id || '',
        action: willBeApplied ? 'applied' : 'removed',
        isMobile: isMobile,
        timestamp: Date.now()
      }));
    } catch (err) {}
  }

  // Intercept both click and change events in capture phase so nothing is missed
  document.addEventListener('click', captureFilterAction, true);
  document.addEventListener('change', captureFilterAction, true);

  function findFilterElement(data) {
    if (!data) return null;

    var isDesktop = window.innerWidth >= 1000;
    var desktopSidebar = document.querySelector('.layout__section--secondary');
    var mobileDrawer = document.getElementById('mobile-collection-filters');

    // Priority 1: Match by data-tag in the active (desktop vs mobile) container
    if (data.tag) {
      if (isDesktop && desktopSidebar) {
        var desktopEl = desktopSidebar.querySelector('[data-action="toggle-tag"][data-tag="' + data.tag + '"]');
        if (desktopEl) return desktopEl;
      } else if (!isDesktop && mobileDrawer) {
        var mobileEl = mobileDrawer.querySelector('[data-action="toggle-tag"][data-tag="' + data.tag + '"]');
        if (mobileEl) return mobileEl;
      }

      // Check all data-tag elements across document and pick visible one
      var allTagEls = document.querySelectorAll('[data-action="toggle-tag"][data-tag="' + data.tag + '"]');
      for (var i = 0; i < allTagEls.length; i++) {
        var item = allTagEls[i];
        if (isDesktop && item.closest('#mobile-collection-filters')) continue;
        if (!isDesktop && !item.closest('#mobile-collection-filters')) continue;
        return item;
      }
      if (allTagEls.length > 0) return allTagEls[0];
    }

    // Priority 2: Match by exact ID
    if (data.id) {
      var byId = document.getElementById(data.id);
      if (byId) return byId;
    }

    // Priority 3: Clear all
    if (data.isClear) {
      var clearTarget = isDesktop && desktopSidebar
        ? desktopSidebar.querySelector('.collection__filter-group summary, .collection__filter-checkbox input')
        : document.querySelector('.collection__filter-group summary, .collection__filter-checkbox input');
      return clearTarget;
    }

    return null;
  }

  function applyFocusToElement(elToFocus) {
    if (!elToFocus) return false;

    // Open closed <details>
    var parentDetails = elToFocus.closest('details');
    if (parentDetails && !parentDetails.open) {
      parentDetails.open = true;
    }

    // Expand collapsed "Ver mais" / view more list (.is-hidden-extra)
    var hiddenItem = elToFocus.closest('.is-hidden-extra');
    if (hiddenItem) {
      var list = hiddenItem.closest('.collection__filter-checkbox-list');
      if (list && list.parentNode) {
        var moreBtn = list.parentNode.querySelector('.collection__filter-toggle-more');
        if (moreBtn && moreBtn.getAttribute('aria-expanded') !== 'true' && moreBtn.dataset.expanded !== '1') {
          moreBtn.click();
        }
      }
      hiddenItem.classList.remove('is-hidden-extra');
    }

    // Ensure focusable
    if (elToFocus.tagName !== 'INPUT' && elToFocus.tagName !== 'BUTTON') {
      if (!elToFocus.hasAttribute('tabindex')) {
        elToFocus.setAttribute('tabindex', '-1');
      }
    }

    try {
      elToFocus.focus({ preventScroll: false });
    } catch (err) {}

    try {
      elToFocus.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (err) {}

    return document.activeElement === elToFocus;
  }

  function announceResults(data) {
    if (!data) return;
    var countEl = document.querySelector('.collection__showing-count, .collection__products-count, .collection__mobile-active-filters-results');
    var countText = countEl ? countEl.textContent.trim().replace(/\s+/g, ' ') : '';

    var message = '';
    if (data.isClear) {
      message = 'All filters cleared. ' + countText;
    } else if (data.name) {
      var actionWord = (data.action === 'removed') ? 'removed' : 'applied';
      message = 'Filter ' + data.name + ' ' + actionWord + '. ' + countText;
    } else {
      message = 'Filters updated. ' + countText;
    }
    message = message.trim();

    var globalAnnouncement = document.getElementById('global-form-success-announcement');
    if (globalAnnouncement) {
      globalAnnouncement.textContent = '';
      setTimeout(function() {
        globalAnnouncement.textContent = message;
      }, 100);
    }

    var filterLiveRegion = document.getElementById('collection-filter-live-region');
    if (filterLiveRegion) {
      filterLiveRegion.textContent = '';
      setTimeout(function() {
        filterLiveRegion.textContent = message;
      }, 100);
    }
  }

  function handleFilterRestoration() {
    var storedData = null;
    try {
      var raw = sessionStorage.getItem('mb_filter_a11y');
      if (raw) storedData = JSON.parse(raw);
    } catch (err) {}

    if (!storedData) return;
    if (Date.now() - (storedData.timestamp || 0) > 30000) {
      try { sessionStorage.removeItem('mb_filter_a11y'); } catch (err) {}
      return;
    }

    var targetEl = findFilterElement(storedData);
    if (targetEl) {
      var attempts = 0;
      var interval = setInterval(function() {
        attempts++;
        var isFocused = applyFocusToElement(targetEl);
        if (isFocused || attempts >= 20) {
          clearInterval(interval);
        }
      }, 80);
    }

    announceResults(storedData);

    // Keep storedData for any subsequent load/theme:loading:end events, then remove
    setTimeout(function() {
      try { sessionStorage.removeItem('mb_filter_a11y'); } catch (err) {}
    }, 3000);
  }

  // 1. Run on initial page load / full reload
  setTimeout(handleFilterRestoration, 150);

  // 2. Also re-run on window load in case late theme scripts shifted focus
  window.addEventListener('load', function() {
    setTimeout(handleFilterRestoration, 100);
  });

  // 3. Run when Shopify AJAX filter completes
  document.addEventListener('theme:loading:end', function() {
    setTimeout(handleFilterRestoration, 100);
  });
}

function updateRegistryHeading() {
  if (window.location.pathname.indexOf('/pages/baby-registry') === -1) return;

  function replaceHeading() {
    const heading = document.querySelector('h2.myregistry-long.myregistry-t1');
    if (heading) {
      const h1 = document.createElement('h1');
      [...heading.attributes].forEach(attr => {
        h1.setAttribute(attr.name, attr.value);
      });
      h1.innerHTML = heading.innerHTML;
      heading.replaceWith(h1);
      return true;
    }
    return false;
  }

  if (!replaceHeading()) {
    const timer = setInterval(function () {
      if (replaceHeading()) {
        clearInterval(timer);
      }
    }, 200);

    setTimeout(function () {
      clearInterval(timer);
    }, 6000);
  }
}

function initArticleLanguageTags() {
  const pageLang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  const items = document.querySelectorAll('.article-item');

  items.forEach(function (item) {
    const titleEl = item.querySelector('.article-item__title a, .article-item__title');
    const excerptEl = item.querySelector('.article-item__excerpt');
    const textToCheck = ((titleEl ? titleEl.textContent : '') + ' ' + (excerptEl ? excerptEl.textContent : '')).trim();
    if (!textToCheck) return;

    // Spanish heuristics
    const isSpanish = /\b(tus|recomendaciones|valen|cómo|para tu|para su|bebé|niños|niñas|guía|consejos|descubre|artículo|embarazo|hacer)\b/i.test(textToCheck) || /[¿¡ñ]/.test(textToCheck);
    // Portuguese heuristics
    const isPortuguese = /\b(suas|indicações|indicaçoes|não|você|voce|bebê|carrinho|enxoval|maternidade|mamãe|mamae|para seu|para sua|como escolher|dicas para|saiba mais|fazer)\b/i.test(textToCheck) || /[ãõêç]/.test(textToCheck);

    // English heuristics
    const isEnglish = /\b(stroller|strollers|car seat|car seats|newest|high chairs|how to|guide|best|tips|top|with|and)\b/i.test(textToCheck);

    var targetLang = null;
    if (isSpanish && pageLang !== 'es') {
      targetLang = 'es';
    } else if (isPortuguese && pageLang !== 'pt') {
      targetLang = 'pt';
    } else if (isEnglish && pageLang !== 'en') {
      targetLang = 'en';
    }

    if (targetLang) {
      if (titleEl && !titleEl.hasAttribute('lang')) {
        titleEl.setAttribute('lang', targetLang);
      }
      if (excerptEl && !excerptEl.hasAttribute('lang')) {
        excerptEl.setAttribute('lang', targetLang);
      }
    }
  });
}

function initIframeTitles() {
  function ensureTitles() {
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach(function (iframe) {
      const currentTitle = (iframe.getAttribute('title') || '').trim();
      if (currentTitle) return;

      const src = (iframe.getAttribute('src') || iframe.getAttribute('data-src') || '').toLowerCase();
      let inferredTitle = 'Embedded content';

      if (src.includes('youtube.com') || src.includes('youtu.be')) {
        inferredTitle = 'YouTube video player';
      } else if (src.includes('vimeo.com')) {
        inferredTitle = 'Vimeo video player';
      } else if (src.includes('google.com/maps') || src.includes('maps.google.com')) {
        inferredTitle = 'Google Maps location';
      } else if (src.includes('collabs.shopify.com') || src.includes('dovetale.com') || iframe.id === 'dovetale-frame') {
        inferredTitle = 'Shopify Collabs Application';
      } else if (src.includes('myregistry.com')) {
        inferredTitle = 'Baby Registry';
      } else if (iframe.id) {
        inferredTitle = iframe.id.replace(/[-_]/g, ' ');
        inferredTitle = inferredTitle.charAt(0).toUpperCase() + inferredTitle.slice(1);
      }

      iframe.setAttribute('title', inferredTitle);
    });
  }

  ensureTitles();

  if (window.MutationObserver && document.body) {
    const observer = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
          ensureTitles();
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('theme:loading:end', ensureTitles);
  window.addEventListener('load', ensureTitles);
}

function removeInvalidLinkRoles() {
  function cleanup() {
    // Remove invalid role="group" from anchor links (e.g. Swiper slides that are links)
    document.querySelectorAll('a[role="group"]').forEach(function (link) {
      link.removeAttribute('role');
      // If Swiper placed slide counting label like "1 / 6" on an anchor, remove it so link's actual content/alt is read
      var ariaLabel = link.getAttribute('aria-label');
      if (ariaLabel && /^\d+\s*\/\s*\d+$/.test(ariaLabel.trim())) {
        link.removeAttribute('aria-label');
      }
    });
  }

  cleanup();

  if (window.MutationObserver && document.body) {
    const observer = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
          cleanup();
          break;
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('theme:loading:end', cleanup);
  window.addEventListener('load', cleanup);
}

function initVariantOptionAccessibility() {
  var selector = '.product-form__single-selector, input[type="radio"].color-swatch__radio, input[type="radio"].variant-swatch__radio, input[type="radio"].block-swatch__radio';

  function syncSelectedValue(input) {
    if (!input) return;
    var optionContainer = input.closest('.product-form__option');
    if (!optionContainer) return;
    var selectedValueEl = optionContainer.querySelector('.product-form__selected-value');
    if (selectedValueEl && input.value) {
      selectedValueEl.textContent = input.value;
    }
  }

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (target && target.matches && target.matches(selector)) {
      syncSelectedValue(target);
    }
  }, true);

  document.addEventListener('input', function (e) {
    var target = e.target;
    if (target && target.matches && target.matches(selector)) {
      syncSelectedValue(target);
    }
  }, true);

  document.addEventListener('focusin', function (e) {
    var target = e.target;
    if (target && target.matches && target.matches(selector) && target.type === 'radio' && target.checked) {
      syncSelectedValue(target);
    }
  }, true);

  document.addEventListener('keyup', function (e) {
    if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Left', 'Right', 'Up', 'Down'].indexOf(e.key) !== -1 || (e.keyCode >= 37 && e.keyCode <= 40)) {
      var active = document.activeElement;
      if (active && active.matches && active.matches(selector)) {
        syncSelectedValue(active);
        active.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }, true);
}
function initImageInfoAccordions() {
  const triggerSelector =
    '.image-info-accordion__trigger, .complex-image-toggle';

  // Delegation also supports descriptions added to product content after load.
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;

    const content = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!content) return;

    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!isExpanded));
    content.hidden = isExpanded;
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const trigger = event.target.closest && event.target.closest(triggerSelector);
    if (!trigger || trigger.getAttribute('aria-expanded') !== 'true') return;

    const content = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!content) return;

    trigger.setAttribute('aria-expanded', 'false');
    content.hidden = true;
    trigger.focus();
  });
}
